export default "__VITE_ASSET__C9lgU3fL__"